<h1 mat-dialog-title>Change User Name</h1>
<div mat-dialog-content>
  <mat-form-field>
    <input [(ngModel)]="data.userName" matInput>
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button (click)="onNoClick()" mat-button>No Thanks</button>
  <button [mat-dialog-close]="data.userName" cdkFocusInitial mat-button>Ok</button>
</div>
